export const iconFontAwesomeHandsHandsBubbles = (
	<i className="fa-solid fa-hands-bubbles"></i>
);
